import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import React, { useState } from "react";

import {
    Home,
    Feather,
    Sun,
    Droplet,
    Zap,
    Thermometer,
    Plus,
    Settings,
    Trash,
    X
} from "react-feather";

import {
    Link
} from "react-router-dom";

import {
    useTranslation
} from "react-i18next";

import NavbarButtonUser from "../Navbar/Buttons/UserButtonNavbar";
import BrandSimple from "../Titles/BrandSimple";

import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Button
} from "reactstrap";

import {
    CgMenuLeftAlt
} from "react-icons/cg";

import {
    Space
} from "antd";

import config from "/app/src/config.js";

import {
    _SOLAR_PHOTOVOLTAIC,
    _SOLAR_THERMAL,
    _THERMAL,
    _WATER,
    getIconComponentByCaller
} from "../../utils/Types";

import {
    TiChevronLeft
} from "react-icons/ti";


const isMobileOnly = config.mbl_version;


/*
 * ============================================================
 * DELETE MODE STORAGE
 * ============================================================
 */

const DELETE_MODE_STORAGE_KEY = "seye.deleteMode";


const isDeleteModeActive = () => {
    return (
        sessionStorage.getItem(
            DELETE_MODE_STORAGE_KEY
        ) === "1"
    );
};


const saveDeleteMode = () => {
    sessionStorage.setItem(
        DELETE_MODE_STORAGE_KEY,
        "1"
    );
};


const clearDeleteMode = () => {
    sessionStorage.removeItem(
        DELETE_MODE_STORAGE_KEY
    );
};


/*
 * ============================================================
 * HELPERS
 * ============================================================
 */

/*
 * Devuelve la ruta del listado del tipo actual.
 *
 * Si NO estamos dentro de un tipo de SeYe,
 * devolvemos null.
 */
const getDeleteModePath = (path) => {

    if (
        path === "plants/thermal" ||
        path === "plants/thermal/:id"
    ) {
        return "/dashboard/plants/thermal";
    }

    if (
        path === "plants/photovoltaic" ||
        path === "plants/photovoltaic/:id"
    ) {
        return "/dashboard/plants/photovoltaic";
    }

    if (
        path === "plants/temperature" ||
        path === "plants/temperature/:id"
    ) {
        return "/dashboard/plants/temperature";
    }

    if (
        path === "plants/water" ||
        path === "plants/water/:id"
    ) {
        return "/dashboard/plants/water";
    }

    return null;
};


/*
 * ============================================================
 * HOME BUTTON
 * ============================================================
 */

const HomeButton = function ({
    onNavigate,
    ...props
}) {

    const { t } = useTranslation();

    return (
        <Link
            to="/dashboard"
            onClick={onNavigate}
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#6e6b7b"
                }}
            >

                <Home
                    className="me-50"
                    size={20}
                />

                {t("dashboard")}

            </div>

        </Link>
    );
};


/*
 * ============================================================
 * ADD BUTTON
 * ============================================================
 */

const AddButton = function ({
    onNavigate,
    ...props
}) {

    const { t } = useTranslation();

    return (
        <Link
            to="/dashboard/plants/add"
            onClick={onNavigate}
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#6e6b7b"
                }}
            >

                <Plus
                    className="me-50"
                    size={20}
                />

                {t("add")}

            </div>

        </Link>
    );
};


/*
 * ============================================================
 * DELETE BUTTON - DESKTOP
 * ============================================================
 */

const DeleteButton = function ({
    deleteModeActive,
    onActivateDeleteMode,
    onCancelDeleteMode,
    ...props
}) {

    const { t } = useTranslation();

    const targetPath =
        getDeleteModePath(
            props.path
        );


    /*
     * Ya estamos en modo eliminar.
     *
     * El botón pasa de:
     *
     *      Borrar
     *
     * a:
     *
     *      Cancelar borrar
     */
    if (deleteModeActive) {

        return (
            <div
                onClick={
                    onCancelDeleteMode
                }
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#ea5455",
                    cursor: "pointer"
                }}
            >

                <X
                    className="me-50"
                    size={20}
                />

                {`${t("cancel")} ${t("delete").toLowerCase()}`}

            </div>
        );
    }


    /*
     * Dashboard / Add / User...
     *
     * Activamos eliminar pero no navegamos.
     */
    if (!targetPath) {

        return (
            <div
                onClick={
                    onActivateDeleteMode
                }
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#ea5455",
                    cursor: "pointer"
                }}
            >

                <Trash
                    className="me-50"
                    size={20}
                />

                {t("delete")}

            </div>
        );
    }


    /*
     * Listado o detalle.
     *
     * Activamos modo eliminar sobre
     * el mismo tipo de SeYe.
     */
    return (
        <Link
            to={targetPath}
            state={{
                deleteMode: true
            }}
            onClick={
                onActivateDeleteMode
            }
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#ea5455"
                }}
            >

                <Trash
                    className="me-50"
                    size={20}
                />

                {t("delete")}

            </div>

        </Link>
    );
};


/*
 * ============================================================
 * GENERIC DROPDOWN LINK
 * ============================================================
 */

const DropdownItemLink = function ({
    onNavigate,
    ...props
}) {

    return (
        <Link
            to={props.path}
            className="d-flex align-items-center"
            onClick={onNavigate}
        >

            <span className="me-50">

                {props.icon}

            </span>

            <span>

                {props.name}

            </span>

        </Link>
    );
};


/*
 * ============================================================
 * PLANT TYPE ITEMS
 * ============================================================
 */

const DropdownItemPlants = function ({
    onNavigate,
    ...props
}) {

    const { t } = useTranslation();

    return (
        <>

            <DropdownItem>

                <DropdownItemLink
                    path="/dashboard/plants/thermal"
                    onNavigate={onNavigate}
                    icon={
                        <Sun size={18} />
                    }
                    name={
                        t("thermal")
                    }
                />

            </DropdownItem>


            <DropdownItem>

                <DropdownItemLink
                    path="/dashboard/plants/photovoltaic"
                    onNavigate={onNavigate}
                    icon={
                        <Zap size={18} />
                    }
                    name={
                        t("photovoltaic")
                    }
                />

            </DropdownItem>


            <DropdownItem>

                <DropdownItemLink
                    path="/dashboard/plants/temperature"
                    onNavigate={onNavigate}
                    icon={
                        <Thermometer size={18} />
                    }
                    name={
                        t("temperature")
                    }
                />

            </DropdownItem>


            <DropdownItem>

                <DropdownItemLink
                    path="/dashboard/plants/water"
                    onNavigate={onNavigate}
                    icon={
                        <Droplet size={18} />
                    }
                    name={
                        t("water")
                    }
                />

            </DropdownItem>

        </>
    );
};


/*
 * ============================================================
 * PLANTS DROPDOWN
 * ============================================================
 */

const DropdownPlantsButton = function ({
    onNavigate,
    ...props
}) {

    const { t } = useTranslation();

    const [
        dropdownOpen,
        setDropdownOpen
    ] = useState(false);


    const toggle = () => {

        setDropdownOpen(
            previous =>
                !previous
        );
    };


    return (
        <Dropdown
            className="rd-mobile-dropdown rd-dropdown"
            isOpen={dropdownOpen}
            toggle={toggle}
            direction="down"
        >

            <DropdownToggle
                className="rd-dropdown-toggle-white"
                caret
            >

                <span className="me-50">
                </span>

                <span
                    style={{
                        color: "#6e6b7b",
                        fontWeight: "normal"
                    }}
                >

                    {t("plants")}

                </span>

            </DropdownToggle>


            <DropdownMenu
                {...props}
                persist={false}
            >

                <DropdownItemPlants
                    onNavigate={onNavigate}
                />

            </DropdownMenu>

        </Dropdown>
    );
};


/*
 * ============================================================
 * MOBILE DELETE LINK
 * ============================================================
 */

const MobileDeleteLink = function ({
    deleteModeActive,
    onActivateDeleteMode,
    onCancelDeleteMode,
    ...props
}) {

    const { t } = useTranslation();

    const targetPath =
        getDeleteModePath(
            props.path
        );


    /*
     * Si ya estamos en modo eliminar,
     * esta opción sirve para cancelarlo.
     *
     * Conservamos Link para mantener exactamente
     * la misma alineación visual del menú.
     */
    if (deleteModeActive) {

        const handleCancelClick = (event) => {

            /*
             * No queremos navegar.
             * Solo cancelar el modo eliminar.
             */
            event.preventDefault();

            onCancelDeleteMode();
        };


        return (
            <Link
                to={
                    targetPath ||
                    "/dashboard"
                }
                onClick={
                    handleCancelClick
                }
                className="d-flex align-items-center"
                style={{
                    width: "100%",
                    color: "#ea5455"
                }}
            >

                <span className="me-50">

                    <X
                        size={18}
                    />

                </span>


                <span>

                    {`${t("cancel")} ${t("delete").toLowerCase()}`}

                </span>

            </Link>
        );
    }


    /*
     * Activar modo eliminar.
     */
    const handleClick = (event) => {

        onActivateDeleteMode();


        /*
         * Si estamos en Dashboard, Add, User, etc.
         * activamos el modo pero NO navegamos.
         */
        if (!targetPath) {

            event.preventDefault();
        }
    };


    return (
        <Link
            to={
                targetPath ||
                "/dashboard"
            }
            state={
                targetPath
                    ? {
                        deleteMode: true
                    }
                    : undefined
            }
            onClick={
                handleClick
            }
            className="d-flex align-items-center"
            style={{
                width: "100%",
                color: "#ea5455"
            }}
        >

            <span className="me-50">

                <Trash
                    size={18}
                />

            </span>


            <span>

                {t("delete")}

            </span>

        </Link>
    );
};


/*
 * ============================================================
 * MOBILE HAMBURGER MENU
 * ============================================================
 */

const MobileHamburgerMenu = function ({
    deleteModeActive,
    onActivateDeleteMode,
    onCancelDeleteMode,
    onNavigate,
    ...props
}) {

    const { t } = useTranslation();


    const [
        dropdownOpen,
        setDropdownOpen
    ] = useState(false);


    const toggle = () => {

        setDropdownOpen(
            previous =>
                !previous
        );
    };


    return (
        <Dropdown
            className="rd-mobile-dropdown rd-dropdown"
            isOpen={dropdownOpen}
            toggle={toggle}
            direction="down"
        >

            <DropdownToggle
                className={
                    `rd-dropdown-toggle-white ${
                        props.path !== "dash"
                            ? "rd-dropdown-toggle-pl-0"
                            : ""
                    }`
                }
                caret
            >

                <CgMenuLeftAlt
                    size={20}
                />

            </DropdownToggle>


            <DropdownMenu
                persist={false}
            >

                {/*
                 * INICIO
                 */}
                <DropdownItem>

                    <DropdownItemLink
                        path="/dashboard"
                        onNavigate={onNavigate}
                        icon={
                            <Home size={18} />
                        }
                        name={
                            t("dashboard")
                        }
                    />

                </DropdownItem>


                <DropdownItem divider />


                {/*
                 * TIPOS DE SEYE
                 */}
                <DropdownItemPlants
                    onNavigate={onNavigate}
                />


                <DropdownItem divider />


                {/*
                 * AÑADIR
                 */}
                <DropdownItem>

                    <DropdownItemLink
                        path="/dashboard/plants/add"
                        onNavigate={onNavigate}
                        icon={
                            <Plus size={18} />
                        }
                        name={
                            t("add")
                        }
                    />

                </DropdownItem>


                {/*
                 * BORRAR / CANCELAR BORRAR
                 */}
                <DropdownItem>

                    <MobileDeleteLink
                        {...props}
                        deleteModeActive={
                            deleteModeActive
                        }
                        onActivateDeleteMode={
                            onActivateDeleteMode
                        }
                        onCancelDeleteMode={
                            onCancelDeleteMode
                        }
                    />

                </DropdownItem>

            </DropdownMenu>

        </Dropdown>
    );
};


/*
 * ============================================================
 * HEADER BY
 * ============================================================
 */

const HeaderBy = ({ ...props }) => {

    const { t } = useTranslation();

    const {
        caller
    } = props;


    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column-reverse"
            }}
        >

            <div>

                {(() => {

                    if (
                        caller === "settings"
                    ) {

                        return t("settings");
                    }


                    if (
                        caller === "add"
                    ) {

                        return t("add");
                    }


                    return "";

                })()}

            </div>


            <div
                style={{
                    paddingBottom: "2px"
                }}
            >

                {(() => {

                    if (
                        caller === "settings"
                    ) {

                        return (
                            <Settings
                                size={20}
                            />
                        );
                    }


                    if (
                        caller === "add"
                    ) {

                        return (
                            <Plus
                                size={20}
                            />
                        );
                    }


                    return null;

                })()}

            </div>

        </div>
    );
};


/*
 * ============================================================
 * HEADER BY PLANT TYPE
 * ============================================================
 */

const HeaderByPlantType = ({ ...props }) => {

    const { t } = useTranslation();

    const {
        caller
    } = props;


    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column-reverse"
            }}
        >

            <div>

                {(() => {

                    if (
                        caller === _SOLAR_THERMAL
                    ) {

                        return t("thermal");
                    }


                    if (
                        caller === _SOLAR_PHOTOVOLTAIC
                    ) {

                        return t("photovoltaic");
                    }


                    if (
                        caller === _THERMAL
                    ) {

                        return t("temperature");
                    }


                    if (
                        caller === _WATER
                    ) {

                        return t("water");
                    }


                    return "";

                })()}

            </div>


            <div
                style={{
                    paddingBottom: "2px"
                }}
            >

                {
                    getIconComponentByCaller(
                        props,
                        {
                            size: 20
                        }
                    )
                }

            </div>

        </div>
    );
};


/*
 * ============================================================
 * PREVIOUS ROUTE
 * ============================================================
 */

const PreviousRouteLink = ({
    deleteModeActive,
    onCancelDeleteMode,
    onNavigate,
    ...props
}) => {

    let to = "";

    const toDashboard = [
        "plants/add",
        "user",
        "plants/thermal",
        "plants/photovoltaic",
        "plants/temperature",
        "plants/water"
    ];

    if (
        toDashboard.includes(
            props.path
        )
    ) {
        to = "/dashboard";

    } else if (
        props.path.includes("/:id")
    ) {
        to =
            `/dashboard/${
                props.path.replace(
                    "/:id",
                    ""
                )
            }`;
    }


    /*
     * ========================================================
     * MODO ELIMINAR
     * ========================================================
     */
    if (deleteModeActive) {

        /*
         * DASHBOARD:
         *
         * Solo cancelar.
         * No navegamos.
         */
        if (props.path === "dash") {

            return (
                <div
                    onClick={
                        onCancelDeleteMode
                    }
                    style={{
                        color: "#6e6b7b",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center"
                    }}
                >

                    &nbsp;&nbsp;

                    <TiChevronLeft
                        size={20}
                    />

                    &nbsp;

                </div>
            );
        }


        /*
         * LISTADO / DETALLE / OTRA VISTA:
         *
         * Cancelar modo eliminar
         * y navegar hacia atrás normalmente.
         */
        return (
            <Link
                to={to}
                onClick={() => {

                    /*
                     * Cancelamos primero el modo eliminar.
                     */
                    onCancelDeleteMode();

                    /*
                     * No llamamos a onNavigate porque
                     * handleCancelDeleteMode ya limpia
                     * deleteMode.
                     */
                }}
                style={
                    to
                        ? {}
                        : {
                            pointerEvents: "none"
                        }
                }
            >

                <div
                    style={{
                        color:
                            to
                                ? "#6e6b7b"
                                : "rgb(189 189 189)"
                    }}
                >

                    &nbsp;&nbsp;

                    <TiChevronLeft
                        size={20}
                    />

                    &nbsp;

                </div>

            </Link>
        );
    }


    /*
     * ========================================================
     * MODO NORMAL
     * ========================================================
     */

    return (
        <>
            {
                props.path === "dash"
                    ? (
                        <></>
                    )
                    : (
                        <Link
                            to={to}
                            onClick={onNavigate}
                            style={
                                (
                                    props.path !== "dash" &&
                                    to
                                )
                                    ? {}
                                    : {
                                        pointerEvents: "none"
                                    }
                            }
                        >

                            <div
                                style={{
                                    color:
                                        (
                                            props.path !== "dash" &&
                                            to
                                        )
                                            ? "#6e6b7b"
                                            : "rgb(189 189 189)"
                                }}
                            >

                                &nbsp;&nbsp;

                                <TiChevronLeft
                                    size={20}
                                />

                                &nbsp;

                            </div>

                        </Link>
                    )
            }
        </>
    );
};


/*
 * ============================================================
 * DASHBOARD MENU
 * ============================================================
 */

export default function DashboardMenu({
    ...props
}) {

    /*
     * Estado local para refrescar inmediatamente
     * la interfaz del menú.
     *
     * La persistencia real está en sessionStorage.
     */
    const [
        deleteModeActive,
        setDeleteModeActive
    ] = useState(
        isDeleteModeActive()
    );


    /*
     * ========================================================
     * ACTIVAR MODO ELIMINAR
     * ========================================================
     */
    const handleActivateDeleteMode = () => {

        saveDeleteMode();

        setDeleteModeActive(
            true
        );
    };


    /*
     * ========================================================
     * CANCELAR MODO ELIMINAR
     * ========================================================
     */
    const handleCancelDeleteMode = () => {

        clearDeleteMode();

        setDeleteModeActive(
            false
        );


        /*
         * Dejamos también disponible un evento global.
         *
         * Esto permite que otros componentes, como
         * PlantsTable, puedan reaccionar inmediatamente
         * si están escuchando el cambio.
         */
        window.dispatchEvent(
            new CustomEvent(
                "seyeDeleteModeChanged",
                {
                    detail: {
                        active: false
                    }
                }
            )
        );
    };


    /*
     * ========================================================
     * NAVEGACIÓN NORMAL
     * ========================================================
     *
     * Cualquier opción normal del menú cancela
     * automáticamente el modo eliminar.
     *
     * Después React Router realiza la navegación normal.
     */
    const handleNormalNavigation = () => {

        if (
            deleteModeActive ||
            isDeleteModeActive()
        ) {

            handleCancelDeleteMode();
        }
    };


    /*
     * El aviso global se muestra solamente
     * cuando todavía no estamos en un listado.
     *
     * Dentro del listado PlantsTable muestra
     * su propio aviso.
     */
    const isPlantList =

        props.path ===
            "plants/thermal" ||

        props.path ===
            "plants/photovoltaic" ||

        props.path ===
            "plants/temperature" ||

        props.path ===
            "plants/water";


    const showGlobalDeleteNotice =

        deleteModeActive &&
        !isPlantList;


    return (
        <>

            <div
                className={
                    `navbar-fixed-2 ${
                        isMobileOnly
                            ? "navbar-fixed-2-mbl"
                            : ""
                    }`
                }
            >

                <div
                    className={
                        `dropdown-on-hover header-navbar navbar-expand-sm navbar navbar-horizontal navbar-light navbar-shadow menu-border ${
                            isMobileOnly
                                ? "menu-border-mbl"
                                : ""
                        }`
                    }
                    role="navigation"
                    data-menu="menu-wrapper"
                    data-menu-type="floating-nav"
                >

                    {isMobileOnly
                        ? (
                            <>

                                {/*
                                 * MOBILE LEFT
                                 */}
                                <div
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        marginLeft: "5px"
                                    }}
                                >

                                    <PreviousRouteLink
                                        {...props}
                                        deleteModeActive={
                                            deleteModeActive
                                        }
                                        onCancelDeleteMode={
                                            handleCancelDeleteMode
                                        }
                                        onNavigate={
                                            handleNormalNavigation
                                        }
                                    />


                                    <MobileHamburgerMenu
                                        {...props}
                                        deleteModeActive={
                                            deleteModeActive
                                        }
                                        onActivateDeleteMode={
                                            handleActivateDeleteMode
                                        }
                                        onCancelDeleteMode={
                                            handleCancelDeleteMode
                                        }
                                        onNavigate={
                                            handleNormalNavigation
                                        }
                                    />

                                </div>


                                {/*
                                 * MOBILE CENTER
                                 */}
                                <div
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >

                                    {
                                        props.path === "dash" &&
                                        (
                                            <BrandSimple
                                                to="/dashboard"
                                                deleteModeActive={deleteModeActive}
                                            />
                                        )
                                    }


                                    {
                                        props.path === "user" &&
                                        (
                                            <HeaderBy
                                                caller="settings"
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/add" &&
                                        (
                                            <HeaderBy
                                                caller="add"
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/thermal" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _SOLAR_THERMAL
                                                }
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/thermal/:id" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _SOLAR_THERMAL
                                                }
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/photovoltaic" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _SOLAR_PHOTOVOLTAIC
                                                }
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/photovoltaic/:id" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _SOLAR_PHOTOVOLTAIC
                                                }
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/temperature" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _THERMAL
                                                }
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/temperature/:id" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _THERMAL
                                                }
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/water" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _WATER
                                                }
                                            />
                                        )
                                    }


                                    {
                                        props.path === "plants/water/:id" &&
                                        (
                                            <HeaderByPlantType
                                                caller={
                                                    _WATER
                                                }
                                            />
                                        )
                                    }

                                </div>


                                {/*
                                 * MOBILE RIGHT
                                 */}
                                <div
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        paddingRight: "5px"
                                    }}
                                >

                                    <NavbarButtonUser
                                        {...props}
                                    />

                                </div>

                            </>
                        )
                        : (
                            <>

                                {/*
                                 * DESKTOP LEFT
                                 */}
                                <div
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        paddingLeft: "20px"
                                    }}
                                >

                                    <Space size="small">

                                        <HomeButton
                                            onNavigate={
                                                handleNormalNavigation
                                            }
                                        />

                                        <DropdownPlantsButton
                                            onNavigate={
                                                handleNormalNavigation
                                            }
                                        />

                                    </Space>

                                </div>


                                {/*
                                 * DESKTOP RIGHT
                                 */}
                                <div
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        paddingRight: "20px"
                                    }}
                                >

                                    <Space size="middle">

                                        <AddButton
                                            onNavigate={
                                                handleNormalNavigation
                                            }
                                        />


                                        <DeleteButton
                                            {...props}
                                            deleteModeActive={
                                                deleteModeActive
                                            }
                                            onActivateDeleteMode={
                                                handleActivateDeleteMode
                                            }
                                            onCancelDeleteMode={
                                                handleCancelDeleteMode
                                            }
                                        />

                                    </Space>

                                </div>

                            </>
                        )
                    }

                </div>

            </div>

        </>
    );
}